import {Inject, Injectable, DOCUMENT} from '@angular/core';
import {EventManager} from '@angular/platform-browser';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {SbbDialogRef} from '@sbb-esta/lyne-angular/dialog';
import {merge, Observable} from 'rxjs';
import {CustomEventQuickActionOpened} from '../util/monitoring/custom-events';
import {MonitoringHelper} from '../util/monitoring/monitoring-helper';
import {Nullable} from '../util/type-helper';
import {QuickActionDialogComponent} from './quick-action-dialog/quick-action-dialog.component';
import {CdDialogService} from '~/app/cd-common/service/dialog.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class QuickActionService {
  private dialogRef: Nullable<SbbDialogRef<QuickActionDialogComponent>>;

  constructor(
    private eventManager: EventManager,
    @Inject(DOCUMENT) private document: Document,
    private dialog: CdDialogService
  ) {
    merge(this.addShortcut('keydown.control.q'), this.addShortcut('keydown.control.k'))
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        if (!this.dialogRef) {
          this.dialogRef = this.dialog.open(QuickActionDialogComponent);
          MonitoringHelper.monitorCustomEvent(new CustomEventQuickActionOpened());
          this.dialogRef.afterClosed.subscribe(() => (this.dialogRef = null));
        }
      });
  }

  addShortcut(eventName: string) {
    return new Observable(observer => {
      const handler = e => {
        e.preventDefault();
        observer.next(e);
      };
      const dispose = this.eventManager.addEventListener(this.document.documentElement, eventName, handler);
      return () => dispose();
    });
  }
}
